import { myapiHost } from '@/conf/env'
import { getJSON, request } from '@/utils/request'

type BankInfo = {
    bank_name: string;
    bank_branch: string;
    card_account: string;
    card_holder: string;
}

export async function get_bank_info() {
  return getJSON<BankInfo>(`${ myapiHost }/get/bank/info`, {
    withCredentials: true,
  })
}

export async function update_bank_info(values: BankInfo) {
    return request<null>({
        url: `${ myapiHost }/update/bank/info`,
        method: 'POST',
        data: values,
        withCredentials: true,
      })
}

export default {
    get_bank_info,
    update_bank_info,
}
